import { render, staticRenderFns } from "./agenda.vue?vue&type=template&id=2b09a1fb&scoped=true"
import script from "./agenda.vue?vue&type=script&lang=js"
export * from "./agenda.vue?vue&type=script&lang=js"
import style0 from "./agenda.vue?vue&type=style&index=0&id=2b09a1fb&prod&lang=scss"
import style1 from "./agenda.vue?vue&type=style&index=1&id=2b09a1fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b09a1fb",
  null
  
)

export default component.exports